import React, { useRef,useState,useEffect } from "react";
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { Button } from 'primereact/button';
import GetRequest from "../../service/GetRequest";
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';

const CloneBranchPopup = () => {
    const stepperRef = useRef(null);
    const [submitted, setSubmitted] = useState(false);

    const [branchList, setBranchList] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState({});

    let emptyBranch = {
        id: null,
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        city: '',
        nativeLanguage: ''
    };

    const [branch, setBranch] = useState(emptyBranch);

    useEffect(()=>{
        setBranch(emptyBranch);
    })

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _branch = { ...branch };
        _branch[`${name}`] = val;

        setBranch(_branch);
    };

    const onClone = () => {
       setSubmitted(true);
    };


    const fetchStoreDetails = () => {
        GetRequest("v1/store-management-service/view/my/store", true)
          .then(response => {
            if (!response || !response.storeBranches || response.storeBranches.length === 0) {
              console.error("Empty response or undefined data for store branches");
            } else {
              setBranchList(response.storeBranches);
              setSelectedBranch(response.storeBranches[0]); // Select the first branch by default
              setSelectedBranchId(response.storeBranches[0].id); //// Select the first branch ID by default
            }
          })
          .catch(error => {
            console.error("Error fetching store details:", error);
          });
      };

      useEffect(() => {
        fetchStoreDetails();
      }, []);


      const handleBranchChange = (e) => {
        const selectedBranch = branchList.find(branch => branch.id === e.target.value);
        setSelectedBranch(selectedBranch);
        setSelectedBranchId(e.target.value);
        console.log("Selected branch:", e.value);
    };

  return (
    <div className="flex justify-content-center">
        <Stepper ref={stepperRef} style={{ flexBasis: '150rem', paddingLeft:'10%',paddingRight:'10%' }}>
            <StepperPanel header="Step 1 : Choose target branch">
                <div className="flex flex-column h-12rem">
                <p className="text-center">
                Inorder to clone a branch, select the target branch which is to be clone.
                    <br/><br/><div className="flex-auto mb-1">
                <label htmlFor="stacked-buttons" className="font-bold block mb-2">Choose a Branch</label>
                <Dropdown
                        value={selectedBranchId}
                        options={branchList.map(branch => ({ label: branch.name, value: branch.id }))}
                        onChange={handleBranchChange}
                        optionLabel="label"
                        placeholder="Select a Branch"
                        className="w-full md:w-14rem mr-auto ml-auto"
                        />

                </div>
                </p>
                
                </div>
                <div className="flex pt-4 justify-content-end">
                    <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={() => stepperRef.current.nextCallback()} />
                </div>
            </StepperPanel>
            <StepperPanel header="Step 2 : Copy Branch products">
                <div className="flex flex-column h-12rem">
                <p className="text-center">
                    Fill the basic details for new branch
                    <br/><br/><br/>
                <div className="field">
                    <label htmlFor="name" className="font-bold">Branch Name</label>
                    <InputText id="name" value={branch.name} onChange={e => onInputChange(e, 'name')} required autoFocus className={classNames({ 'p-invalid': submitted && !branch.name })} />
                    {submitted && !branch.name && <small className="p-error">Name is required.</small>}
                </div>
                <div className="field">
                    <label htmlFor="description" className="font-bold">Description</label>
                    <InputTextarea id="description" value={branch.description} onChange={e => onInputChange(e, 'description')} required rows={3} cols={20} />
                </div>
                <div className="field">
                    <label htmlFor="addressLine1" className="font-bold">Address Line 1</label>
                    <InputText id="addressLine1" value={branch.addressLine1} onChange={e => onInputChange(e, 'addressLine1')} required />
                </div>
                <div className="field">
                    <label htmlFor="addressLine2" className="font-bold">Address Line 2</label>
                    <InputText id="addressLine2" value={branch.addressLine2} onChange={e => onInputChange(e, 'addressLine2')} />
                </div>
                <div className="field">
                    <label htmlFor="addressLine3" className="font-bold">Address Line 3</label>
                    <InputText id="addressLine3" value={branch.addressLine3} onChange={e => onInputChange(e, 'addressLine3')} />
                </div>
                <div className="field">
                    <label htmlFor="city" className="font-bold">City</label>
                    <InputText id="city" value={branch.city} onChange={e => onInputChange(e, 'city')} required />
                </div>
                <div className="field">
                    <label htmlFor="nativeLanguage" className="font-bold">Language</label>
                    <InputText id="nativeLanguage" value={branch.nativeLanguage} onChange={e => onInputChange(e, 'nativeLanguage')} required />
                </div>
                
                <br/><br/><br/> </p>          
                
                    <Button label="Clone" severity="secondary" icon="pi pi-copy" loading={submitted} onClick={onClone} />
              
                        
                </div>
                
            </StepperPanel>
        </Stepper>
    </div>
  )
}

export default CloneBranchPopup
